import { render } from "./business-settings.vue?vue&type=template&id=1fff73fe"
import script from "./business-settings.vue?vue&type=script&lang=js"
export * from "./business-settings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__